export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13159.8c6f086b.jpg";